import styled from '@emotion/styled'
import { DialogActions } from '@mui/material'
import i18n from '../../../../../utilities/i18n'
import Button from '../../../../Buttons/Button'
import { getThemeSpacing } from '../../../../styles/appTheme'

const StyledList = styled('ul')({
    paddingLeft: getThemeSpacing(2),
})

interface IBroadcasterRules {
    onCancel(): void
    onAgree(): void
}

const BroadcasterRules = (props: IBroadcasterRules) => {
    const { onCancel, onAgree } = props
    return (
        <div className="card">
            <div className="card-contents">
                <h4>{i18n.t('userBroadcast.youMustAgreeRules')}:</h4>
                <StyledList>
                    <li>{i18n.t('userBroadcast.broadcastRule1')}</li>
                    <li>{i18n.t('userBroadcast.broadcastRule2')}</li>
                    <li>{i18n.t('userBroadcast.broadcastRule3')}</li>
                    <li>{i18n.t('userBroadcast.broadcastRule4')}</li>
                </StyledList>
                {i18n.t('userBroadcast.rulesMoreDetails')}&nbsp;
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://wiki.myfreecams.com/wiki/Rules_and_Guidelines"
                >
                    {i18n.t('userBroadcast.wiki')}
                </a>
                .
            </div>
            <DialogActions>
                <Button onClick={onCancel} cancel size="medium">
                    {i18n.t('dialogs.cancel')}
                </Button>
                <Button onClick={onAgree} size="medium">
                    {i18n.t('userBroadcast.iAgree')}
                </Button>
            </DialogActions>
        </div>
    )
}

export default BroadcasterRules
